(function () {
  // 等待 custom element 注册完成后再 patch
  function patchDiamondFilter() {
    // 找到页面上的 diamond-filter 元素（标签名动态生成，用属性选择器）
    const filterEl = document.querySelector('[class^="ai-diamond-filter-"]');
    if (!filterEl) return;

    // 找到商品 grid 容器
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    const sectionId = gridContainer.dataset.sectionId;

    // 覆盖实例上的 updateURL 方法
    const proto = Object.getPrototypeOf(filterEl);
    const originalUpdateURL = proto.updateURL;

    proto.updateURL = async function () {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      let sort_by = params.get('filter.p.m.custom.sort_by') || 'manual';

      // 同原逻辑：构建筛选参数
      if (this.filters.shape) {
        params.set('filter.p.m.custom.shop_by_shape', this.filters.shape);
        params.set('sort_by', sort_by);
      } else {
        params.delete('filter.p.m.custom.shop_by_shape');
      }

      if (this.filters.metal) {
        params.set('filter.p.m.custom.shop_by_material', this.filters.metal);
        params.set('sort_by', sort_by);
      } else {
        params.delete('filter.p.m.custom.shop_by_material');
      }

      if (this.filters.carat) {
        params.set('filter.v.option.main stone carat weight', this.filters.carat);
        params.set('sort_by', sort_by);
      } else {
        params.delete('filter.v.option.main stone carat weight');
      }

      if (this.filters.settings_style) {
        params.set('filter.p.m.custom.setting_style', this.filters.settings_style);
        params.set('sort_by', sort_by);
      } else {
        params.delete('filter.p.m.custom.setting_style');
      }

      const newPath = `${url.pathname}?${params.toString()}`;

      // ✅ 1. 更新地址栏，不刷新页面
      history.pushState({}, '', newPath);

      // ✅ 2. 用 Section Rendering API 局部刷新商品列表
      const fetchUrl = `${url.pathname}?${params.toString()}&sections=${sectionId}`;

      gridContainer.style.opacity = '0.5';
      gridContainer.style.pointerEvents = 'none';

      try {
        const response = await fetch(fetchUrl);
        const data = await response.json();

        const html = data[sectionId];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.getElementById('ProductGridContainer');

        if (newGrid) {
          gridContainer.innerHTML = newGrid.innerHTML;
        }

        // 触发自定义事件，供其他脚本监听
        document.dispatchEvent(new CustomEvent('collection:rerender', {
          detail: { url: newPath }
        }));

      } catch (err) {
        console.error('[DiamondFilter] Ajax filter failed:', err);
        // 降级：整页跳转
        window.location.href = newPath;
      } finally {
        gridContainer.style.opacity = '';
        gridContainer.style.pointerEvents = '';
      }
    };
  }

  // 处理浏览器前进/后退
  window.addEventListener('popstate', () => {
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    const sectionId = gridContainer.dataset.sectionId;
    const url = new URL(window.location.href);
    const fetchUrl = `${url.pathname}?${url.search}&sections=${sectionId}`;

    fetch(fetchUrl)
      .then(r => r.json())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data[sectionId], 'text/html');
        const newGrid = doc.getElementById('ProductGridContainer');
        if (newGrid) gridContainer.innerHTML = newGrid.innerHTML;
      });
  });

  // DOM 就绪后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchDiamondFilter);
  } else {
    patchDiamondFilter();
  }
})();
